var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carousel_swipe",attrs:{"id":'carousel_swipe' + _vm.id},on:{"mouseenter":function($event){$event.stopPropagation();return _vm.handleStop.apply(null, arguments)},"mouseleave":function($event){$event.stopPropagation();return _vm.handleGo.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }